/*! query-string.js */

const REGEXP_QS = /([^?=&]+)(=([^&]*))?/g;

class QueryString {
    /**
     * Converts params object to query string
     * @param {object} params
     * @return {string}
     */
    static toQueryString(params) {
        return Object.keys(params)
            .reduce((result, k, i) => `${ result }${ i > 0 ? "&" : "" }${ encodeURIComponent(k) }=${ encodeURIComponent(params[k]) }`, "");
    }

    /**
     * Converts query-string into an object hash
     * @function
     * @param search
     * @returns {object}
     */
    static parseQueryString(search) {
        if (!search || typeof search !== "string") {
            return {};
        }

        const params = {};

        search.replace(REGEXP_QS, ($0, paramName, $2, paramValue) => {
            const param = decodeURIComponent(paramName);
            const value = paramValue !== undefined ? decodeURIComponent(paramValue).replace("+", " ") : undefined;

            if (params.hasOwnProperty(param)) {
                if (Array.isArray(params[param])) {
                    return params[param].push(value);
                }

                params[param] = [params[param], value];
                return;
            }

            params[param] = value;
        });

        return Object.freeze(params);
    }
}

export default QueryString;
